import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_TICKET] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.ticket = payload
  },
  [types.SET_TICKETS] (state, payload) {
    state.tickets = payload.data
    state.pagination = payload.meta.pagination
  }
}
